import { outputToObservable } from '@angular/core/rxjs-interop';

import { switchMap } from 'rxjs';

import { BaseToastComponent } from '../../toast/base-toast.component';
import { TInsertedToast } from '../toast.types';

import { ToastContainer } from './toast-container.class';
import { ToastConfig } from './toast-config.class';

export class ToastRef<
  Config extends ToastConfig = ToastConfig,
  Component extends BaseToastComponent = BaseToastComponent,
> {
  get instance(): Component | null {
    return this.toast.instance || null;
  }

  constructor(
    private toastContainer: ToastContainer,
    private toast: TInsertedToast<Config, Component>,
  ) {}

  close() {
    return this.toastContainer.destroy(this.toast);
  }

  onClose() {
    return outputToObservable(this.instance!.destroyEvent);
  }

  onClick() {
    return outputToObservable(this.instance!.clickEvent);
  }

  afterClose() {
    return outputToObservable(this.instance!.destroyEvent).pipe(
      switchMap(() => this.toastContainer.destroy(this.toast)),
    );
  }
}
